export default "__VITE_ASSET__d962c337__"